var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardContextMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#80888D",
    d: "M7.19629 14.0371C11.0107 14.0371 14.1689 10.8721 14.1689 7.06445C14.1689 3.25 11.0039 0.0917969 7.18945 0.0917969C3.38184 0.0917969 0.223633 3.25 0.223633 7.06445C0.223633 10.8721 3.38867 14.0371 7.19629 14.0371ZM7.19629 12.875C3.96973 12.875 1.39258 10.291 1.39258 7.06445C1.39258 3.83789 3.96289 1.25391 7.18945 1.25391C10.416 1.25391 13 3.83789 13.0068 7.06445C13.0137 10.291 10.4229 12.875 7.19629 12.875ZM4.00391 8.0625C4.55078 8.0625 4.99512 7.61133 4.99512 7.06445C4.99512 6.51758 4.54395 6.06641 4.00391 6.06641C3.4502 6.06641 3.00586 6.51758 3.00586 7.06445C3.00586 7.61133 3.4502 8.0625 4.00391 8.0625ZM7.18945 8.0625C7.73633 8.0625 8.1875 7.61133 8.1875 7.06445C8.1875 6.51758 7.73633 6.06641 7.18945 6.06641C6.64258 6.06641 6.19141 6.51758 6.19141 7.06445C6.19141 7.61133 6.64258 8.0625 7.18945 8.0625ZM10.3818 8.0625C10.9287 8.0625 11.373 7.61133 11.373 7.06445C11.373 6.51758 10.9287 6.06641 10.3818 6.06641C9.82812 6.06641 9.38379 6.51758 9.38379 7.06445C9.38379 7.61133 9.82812 8.0625 10.3818 8.0625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardContextMenu);
export default __webpack_public_path__ + "static/media/card-context-menu.715f7a43a54cdfeb0a23122d0adaf825.svg";
export { ForwardRef as ReactComponent };